<img [src]="languageService.getFlag(code)" class="language-flag" /> {{ languageService.getTranslationKey(code) | translate }}
